import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test, group, each } from 'vest'
import { RegularScope, RegularScopeApplyTo } from '../../../../../../typings'
import { SCOPE_OPTIONS } from '../../../../../ItemsView/typing'
import { messages } from './messages'

export function scopeValidation(intl: IntlShape, name: string) {
  return create((scope: RegularScope) => {
    const { $t } = intl
    const { validation } = messages

    group('scope', () => {
      test(name, () => {
        enforce(scope.applyTo).isNotUndefined()
      })

      omitWhen(scope.applyTo === RegularScopeApplyTo.allItems, () => {
        test(name, $t(validation.required), () => {
          const totalItems = Object.values(SCOPE_OPTIONS).reduce(
            (sum, field) => sum + (scope[field]?.items?.length ?? 0),
            0
          )
          enforce(totalItems).greaterThan(0)
        })

        each(Object.values(SCOPE_OPTIONS), (option) => {
          test(option, () => {
            const totalItems = Object.values(SCOPE_OPTIONS).reduce(
              (sum, field) => sum + (scope[field]?.items?.length ?? 0),
              0
            )
            enforce(totalItems).greaterThan(0)
          })

          omitWhen(scope[option] === undefined, () => {
            test(`${option}.items`, $t(validation.required), () => {
              const totalItems = Object.values(SCOPE_OPTIONS).reduce(
                (sum, field) => sum + (scope[field]?.items?.length ?? 0),
                0
              )
              enforce(totalItems).greaterThan(0)
            })
          })
        })
      })
    })
  })
}
